/**
 * External Imports
 */
import styled from 'styled-components';

export const InputHeading = styled.div`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  margin-top: 12px;
`;

export const TextDiv = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: #191919;
`;
